import { GameState } from '../systems/GameState';
import { generateStyledMessage } from '../systems/DialogueSystem';
import { CONSTANTS } from '../data';

const gameState = GameState.getInstance();

function glitchText(text: string): string {
    if (Math.random() > CONSTANTS.VIRUS.glitchChance) {
        return text;
    }
    const chars = text.split('');
    for (let i = 0; i < chars.length; i++) {
        if (Math.random() < 0.15) { // 15% chance to corrupt a character
            if (chars[i] !== ' ') {
                chars[i] = CONSTANTS.VIRUS.glitchChars[Math.floor(Math.random() * CONSTANTS.VIRUS.glitchChars.length)];
            }
        }
    }
    return chars.join('');
}

export function typeText(element: HTMLElement, text: string, speed = 50) {
  let i = 0;
  element.innerHTML = '';
  const cursorSpan = '<span class="cursor">█</span>';

  const typingInterval = setInterval(() => {
    if (i < text.length) {
      element.innerHTML = text.substring(0, i + 1) + cursorSpan;
      i++;
    } else {
      clearInterval(typingInterval);
    }
  }, speed);
}

export function typeAIMessage(message: string, discovered: Set<string>, suppressHistoryPush: boolean = false) {
  const terminalContent = document.getElementById('terminal-content');
  if (!terminalContent) return;

  let styledMessage = generateStyledMessage(message, discovered);
  if (gameState.virusActive) {
    styledMessage = glitchText(styledMessage);
  }
  typeText(terminalContent, styledMessage);
  if (!suppressHistoryPush) {
    gameState.aiHistory.push(message);
  }
}
